import { useEffect, useRef } from "react";

const useInterval = (callback, delay) => {

    const savedCallBack = useRef();

    // Remember the latest callback
    useEffect(() => {
        savedCallBack.current = callback;
    }, [callback]);

    // Setup the interval
    useEffect(() => {
        const tick = () => {
            savedCallBack.current();
        }
        if(delay !== null) {
            const id = setInterval(tick, delay);
            return () => {
                clearInterval(id);
            };
        }
    }, [callback, delay]);
};

export default useInterval;